import {useEffect, useRef } from 'react';
import Typist from 'react-typist';
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep","Oct", "Nov", "Dec"];
const InitProgram = ({setEndLine}) => {
	const date =  new Date();
	const time = date.toLocaleTimeString();
	const day = date.getDay();
	const dateNum = date.getDate();
	const month = date.getMonth();
	console.log(time, days[day], months[month], dateNum);

	const linesRef = useRef([]);
	const rootProgram = {
		1: { text: 'Booting up system...', timeout: 3000 },
		2: { text: '        Initiating kernel...', timeout: 150 },
		3: { text: '        Kernel boot successful...', timeout: 100 },
		4: { text: 'Starting virtual layers...', timeout: 150 },
		5: { text: '        Virtual layer 1: blog.core Initialized', timeout: 50 },
		6: { text: '        Virtual layer 2: post.core Initialized', timeout: 75 },
		7: { text: '        Virtual layer 3: thoughts.core Initialized', timeout: 100 },
		8: { text: '        All virtual layers active...', timeout: 400 },
		9: { text: 'Starting AI core...', timeout: 200 },
		10: { text: '    AI Core boot successful...', timeout: 75 },
		11: { text: '    Loading AI subsystems...', timeout: 150 },
		12: { text: '           Subsystems 1: Loaded', timeout: 75 },
		13: { text: '           Subsystems 2: Loaded', timeout: 75 },
		14: { text: '           Subsystems 3: Loaded', timeout: 75 },
		15: { text: '    All AI subsystems active...', timeout: 100 },
		16: { text: 'core fully functional...', timeout: 1500 },
		17: { text: 'boot on ./dev005', timeout: 200 },
	};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		let totalTimeout = 0;
		Object.keys(rootProgram).forEach((key) => {
			const { text, timeout } = rootProgram[key];
			totalTimeout += timeout;
			setTimeout(() => {
				linesRef.current = [...linesRef.current, text];
				document.getElementById('console').innerText = linesRef.current.join('\n');
			}, totalTimeout);
		});
		setTimeout(() => {
			setEndLine(true);
		}, 5000);
		// eslint-disable-next-line
	}, []);
	return (
		<>
			<section className="loading-programme-container">
				<div>Last login: {`${days[day]} ${months[month]} ${dateNum}  ${time.split(/(PM|AM)/g)[0]}`} on ttys000</div>
				<div style={{ display: 'flex' }}>
					<div>nixoals@u-demos ~ %</div>
					<Typist>
						<span>&nbsp;&nbsp;./externalize_real_web.sh</span>
					</Typist>
				</div>
				<div style={{ color: 'green' }}>
					<pre id="console"></pre>
				</div>
			</section>
		</>
	);
};

export default InitProgram;
